import { useContext } from 'react'
import { PartnerContext } from '../context/partnerContext'

export const usePartner = () => useContext(PartnerContext)
